var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('a-breadcrumb',_vm._l((_vm.breadNameList),function(item){return _c('a-breadcrumb-item',{key:item.id},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }